(function () {
  function updatePanelTop() {
    var header = document.querySelector('.t4s-section-header');
    var bottom = header ? header.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty('--yaomri-side-panel-top', Math.max(bottom, 0) + 'px');
  }

  function syncOpenState() {
    var isOpen = Boolean(document.querySelector('[data-yaomri-side-menu][open]'));

    document.documentElement.classList.toggle(
      'yaomri-side-menu-is-open',
      isOpen
    );

    return isOpen;
  }

  function closeMenus(exceptMenu) {
    document.querySelectorAll('[data-yaomri-side-menu][open]').forEach(function (menu) {
      if (menu !== exceptMenu) menu.removeAttribute('open');
    });
    syncOpenState();
  }

  function initMenu(menu) {
    var summary = menu.querySelector(':scope > summary');
    var closeTimer;

    if (!summary) return;

    function openMenu() {
      if (!window.matchMedia('(min-width: 1025px)').matches) return;
      clearTimeout(closeTimer);
      closeMenus(menu);
      menu.setAttribute('open', '');
      syncOpenState();
      updatePanelTop();
    }

    function queueClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        menu.removeAttribute('open');
        syncOpenState();
      }, 120);
    }

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', queueClose);
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || !menu.contains(event.relatedTarget)) queueClose();
    });

    summary.addEventListener('click', function (event) {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        event.preventDefault();
        openMenu();
      }
    });

    menu.addEventListener('toggle', syncOpenState);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-yaomri-side-menu-close]')) {
      closeMenus();
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') closeMenus();
  });

  window.addEventListener('resize', updatePanelTop);
  window.addEventListener('scroll', updatePanelTop, { passive: true });
  document.addEventListener('DOMContentLoaded', function () {
    updatePanelTop();
    document.querySelectorAll('[data-yaomri-side-menu]').forEach(initMenu);
  });
})();
